import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteSvg, EditSvg } from '../../../assets/svg';
import * as EcommerceActions from '../../../redux/actions/ecommerceAction.js';

const DisplayAttribute = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ecommerceAttributeData } = useSelector(state => state.ecommerceReducer);

  useEffect(() => {
    //! Dispatching API for Getting Category
    dispatch(EcommerceActions.getEcommerceAttribute())
  }, []);

  return (
    <>
      <div style={{ padding: "20px", color: "#000", borderRadius: "10px", fontSize: "15px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher' }}>
          <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Attribute</div>
          <div onClick={() => navigate("/e-commerce/add-attribute")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "2px 5px", borderRadius: "5px", display: "flex", alignItems: "center", gap: "5px", cursor: "pointer" }}>
            <div style={{ fontSize: "15px" }}>Add</div>
            <div style={{ fontWeight: "bold", fontSize: "18px" }}>+</div>
          </div>
        </div>

        <div style={{ marginBottom: "20px" }}>Showing 1 - {ecommerceAttributeData.length} of {ecommerceAttributeData?.length} results</div>

        <div style={{ display: "flex", gap: "30px", flexWrap: "wrap", justifyContent: "space-evenly" }}>
          {ecommerceAttributeData?.map((value, index) => (
            <div key={index} style={{ minWidth: "250px", backgroundColor: "#fff", borderRadius: "3.5px", boxShadow: '0px 0px 5px lightgrey' }}>
              <div>
                <div style={{ padding: "15px", borderBottom: "1px solid #cfcfcf" }}>Attribute</div>
                <div style={{ padding: "15px", borderBottom: "1px solid #cfcfcf", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>{value?.title}</div>
                  <div>Add Value</div>
                </div>
                {value?.values?.map((curr, currIndex) => (
                  <div key={currIndex} style={{ padding: "10px 15px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div>{curr}</div>
                    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                      <div style={{ cursor: "pointer" }}><EditSvg w='16' h='16' /></div>
                      <div onClick={() => console.log(`Parent ID : ${value?._id} , Value Id : ${currIndex + 1}`)} style={{ cursor: "pointer" }}><DeleteSvg w='16' h='16' /></div>
                    </div>
                  </div>
                ))}
                <div style={{ padding: "15px", display: "flex", justifyContent: "space-between", gap: "20px", borderTop: "1px solid #cfcfcf" }}>
                  <div onClick={() => navigate('/e-commerce/add-attribute', { state: { stateData: value } })} style={{ textAlign: "center", flexBasis: "50%", cursor: "pointer" }}><EditSvg /></div>
                  <div style={{ border: "0.2px solid #cfcfcf" }}></div>
                  <div onClick={() => dispatch(EcommerceActions.deleteEcommerceAttribute({ attributeId: value?._id }))} style={{ textAlign: "center", flexBasis: "50%", cursor: "pointer" }}><DeleteSvg /></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default DisplayAttribute;